import { FormControl, FormGroupDirective, NgForm } from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";

export class FormStateMatcher implements ErrorStateMatcher {

    private errorCode: string;  
    constructor(errorCode: string) {  
      this.errorCode = errorCode;  
    }
  
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      if (!control || !form) {
        return true;
      }
      return (control.touched || control.dirty) && (control.invalid || form.hasError(this.errorCode));
  
    }
  
  }

  /** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}